import { ParsedUrlQuery } from 'querystring';

export function getPropertyType(query: ParsedUrlQuery) {
    if (query['property_type']) {
        return query['property_type'];
    }

    if (!query['search-path']) {
        return 'property';
    }

    return (
        ['property', 'houses', 'flats', 'farms_land'].filter(
            (propertyType) => propertyType === query['search-path']?.[0]
        )[0] || 'property'
    );
}
